import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControl } from '../base.control';

@Component({
  selector: 'sh-text-area',
  templateUrl: './text-area.control.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaControl),
      multi: true,
    },
    {
      provide: BaseControl,
      useExisting: forwardRef(() => TextAreaControl),
    },
  ],
  standalone: false,
})
export class TextAreaControl extends BaseControl<string | null> {}
